import styled from 'styled-components'

export const StyledFooter = styled.footer`
  text-align: center;
  margin: 3rem auto;
`
